import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const RoleBasedRedirect = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  // Redirect based on user role
  if (user.user_role === 'superadmin' || user.user_role === 'admin') {
    return <Navigate to="/admin-panel" />;
  } else if (user.user_role === 'owner') {
    return <Navigate to="/dashboard" />;
  } else {
    // seller
    return <Navigate to="/pos" />;
  }
};

export default RoleBasedRedirect;
